import React from 'react'

import { Button, ButtonGroup, Checkbox, Flex,Header, StatusMessage, styled,Text } from '@driftt/dds'

import { EMPTY_CONDITION, useAdvancedPreferences } from 'hooks/useAdvancedPreferences'

import CustomGlobalFilter from './CustomGlobalFilter'

const SettingBlock = styled('div', {
  margin: '0px 0px 24px 0'
})

const SettingHeader = styled('div', {
  marginBottom: '8px'
})

const SettingInput = styled('div', {
  marginBottom: '12px'
})

const AdvancedPreferences = ({ setFiltersUpdated } : { setFiltersUpdated: (updated: boolean) => void}) => {
  const { 
    inCRM, 
    setInCRM,
    hideCurrent, 
    setHideCurrent,
    currentCustomerCondition,
    setCurrentCustomerCondition,
    hideDisqualified, 
    setHideDisqualified,
    disqualifiedCondition,
    setDisqualifiedCondition,
    showSaveCancel,
    setShowSaveCancel,
    validateToSave,
    onCancel,
    invalidState
  } = useAdvancedPreferences(setFiltersUpdated)


  return (
    <Flex direction='column' justifyContent='space-between' css={{height: '100%'}}>
      <Flex.Item>
        <SettingBlock>
          <SettingHeader >
            <Header variant='h3'>We want to see activity in prospector from...</Header>
          </SettingHeader>
          <SettingInput>
            <Checkbox 
              label='Accounts that are not currently in our CRM' 
              description={`Engaged accounts that are not found in your CRM will be visible to anyone 
              who uses Drift's Prospector Dashboard or Account activity.`}
              onChange={(checked: boolean) => {
                setInCRM(checked)
                setShowSaveCancel(true)
              }}
              checked={inCRM}
            />
          </SettingInput>
        </SettingBlock>
        <SettingBlock> 
          <SettingHeader>
            <Header variant='h3'>{`We don't want to see activity in prospector from...`}</Header>
            <Text variant='subtitle2'>
              {`Hide accounts that match the filters below for all users that use Drift's 
              Prospector Dashboard or Account Activity.`}
            </Text>
          </SettingHeader>
          <CustomGlobalFilter 
            settingLabel='Accounts that are current customers'
            settingIsEnabled={hideCurrent ?? false}
            setIsEnabled={setHideCurrent} 
            condition={currentCustomerCondition ?? EMPTY_CONDITION} 
            setCondition={setCurrentCustomerCondition}
            setShowSaveCancel={setShowSaveCancel}        
          />
          <CustomGlobalFilter 
            settingLabel='Accounts that have been recently disqualified'
            settingIsEnabled={hideDisqualified ?? false}
            setIsEnabled={setHideDisqualified} 
            condition={disqualifiedCondition ?? EMPTY_CONDITION} 
            setCondition={setDisqualifiedCondition}   
            setShowSaveCancel={setShowSaveCancel}        
          />
        </SettingBlock>
      </Flex.Item>
      <Flex.Item alignSelf='end'>
        <ButtonGroup>
          {invalidState && <StatusMessage variant='error'>Please select values for the enabled filters</StatusMessage>}
          <Button variant="secondary" onClick={onCancel} disabled={!showSaveCancel}>
              Cancel
            </Button>
            <Button variant="primary" onClick={validateToSave} disabled={!showSaveCancel}>Save</Button>
        </ButtonGroup>
      </Flex.Item>
    </Flex>

  )
}

export default AdvancedPreferences
